import { render, staticRenderFns } from "./xbn_sales.vue?vue&type=template&id=679d7295&"
import script from "./xbn_sales.vue?vue&type=script&lang=js&"
export * from "./xbn_sales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports